'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mount = mount;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxShip = require('redux-ship');

var Ship = _interopRequireWildcard(_reduxShip);

var _controller = require('./controller');

var Controller = _interopRequireWildcard(_controller);

var _view = require('./view');

var _view2 = _interopRequireDefault(_view);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mount(domId) {
  function dispatch(action) {
    Ship.run(function () {}, _store2.default, Controller.control(action));
  }

  function render() {
    _reactDom2.default.render(_react2.default.createElement(_view2.default, { dispatch: dispatch, state: _store2.default.getState() }), document.getElementById(domId));
  }

  _store2.default.subscribe(render);
  render();

  return function (control) {
    return regeneratorRuntime.mark(function _callee(action) {
      var _ref, snapshot;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.delegateYield(Ship.snap(control(action)), 't0', 1);

            case 1:
              _ref = _context.t0;
              snapshot = _ref.snapshot;

              dispatch({
                type: 'AddLog',
                action: action,
                snapshot: snapshot
              });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    });
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/devtools/dist/main/lib.js
 ** module id = 394
 ** module chunks = 0
 **/